import { createClient } from '@supabase/supabase-js';

// Konfiguration hämtas från miljövariabler (sätts i .env.local lokalt och i
// Netlifys "Environment variables" vid deploy). Anon-nyckeln är avsedd att
// exponeras i frontend – säkerheten sköts av Row Level Security i Supabase.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Namnet på Storage-bucketen där galleribilder lagras.
export const GALLERY_BUCKET = 'gallery';

// True när både URL och nyckel är satta – annars faller sajten tillbaka på
// de statiska bilderna och admin-sidan visar en installationsinstruktion.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
